import React from 'react';
import * as PropTypes from 'prop-types';

function Hour(props) {
  const { children, displaySideHours, onCalendarCaseClick, displayType, hour } = props;
  const className = displayType === 'Day' ? 'calendarcase dayview' : 'calendarcase';
  return (
    <div className={className} onClick={onCalendarCaseClick} id={hour.datetime}>
      {children}
      {displaySideHours && (
        <div className="linesofdays">
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>
      )}
    </div>
  );
}

Hour.defaultProps = {
  onCalendarCaseClick: null,
  displayType: '',
};

Hour.propTypes = {
  onCalendarCaseClick: PropTypes.func,
  displaySideHours: PropTypes.bool.isRequired,
  displayType: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default Hour;
